import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './style/index.less';
import * as Sentry from '@sentry/react';
import { patchDomForReactCompatibility } from './lib/dom-patch';

// Patch DOM methods to prevent crashes from external DOM modifications
// (browser extensions, translation tools, Samsung Internet features, etc.)
patchDomForReactCompatibility();

const env = import.meta.env;
Sentry.init({
  dsn: 'https://6717c651a58345d5bd77879f6d2036a9@o4505057170227200.ingest.sentry.io/4505057174618112',
  integrations: [
    new Sentry.Replay({
      maskAllInputs: false,
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  environment: env.VITE_ENVIRONMENT,
  enabled: env.VITE_ENVIRONMENT !== 'develop',
  attachStacktrace: true,
  replaysOnErrorSampleRate: 1.0,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
